import { Component, createRef } from "react"

/* Components */
import { Icon } from "../../components"

/* REST API */
import { archiveService } from "../../api/Organization"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import ServiceModal from "./ServiceModal"

/* Widgets */
import { toast, confirm } from "../common"


/* Widget Services Tab — the price list of the point. A service is created and edited here, and
   it is never deleted: it leaves for the archive, so a booking made for it keeps what it was made for */
class ServicesTab extends Component {

    constructor() {
        super()

        this.state = {
            /* 1 — the price list, 0 — the archive */
            filter: 1
        }

        /* The form of the service is opened by the reference */
        this._service = createRef()
    }

    /* Send the service to the archive or bring it back to the price list */
    archive = (service, active) => {

        const { data, reload } = this.props

        const question = active
            ? { title: `Вернуть «${service.name}» в прайс-лист?`, confirm: "Да, вернуть", color: "#0279fc" }
            : { title: `Архивировать «${service.name}»?`, confirm: "Да, архивировать", color: "#f44336" }

        confirm({
            title: question.title,
            text: "Услуга не удаляется — прошлые записи сохранят её",
            confirmText: question.confirm,
            cancelText: "Отмена"
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            archiveService({ id: service.id, organizationID: data.organization.id, active: active ? 1 : 0 }).then(response => {
                if (response.status === 200) {
                    reload()
                    toast.success(active ? "Услуга вернулась в прайс-лист" : "Услуга в архиве")
                }
                else {
                    toast.error("Не удалось изменить услугу")
                }
            }).catch(() => {
                toast.error("Не удалось изменить услугу")
            })
        })
    }

    render = () => {

        /* Fields */
        const { filter } = this.state
        const { data, reload } = this.props
        const { services } = data

        /* The price list and the archive are counted apart */
        const active = services.filter(service => parseInt(service.active) !== 0)
        const archived = services.filter(service => parseInt(service.active) === 0)
        const shown = filter === 1 ? active : archived

        return (
            <div className="organization-details-body">

                <div className="organization-details-toolbar">

                    <div className="organization-details-switch">
                        <div onClick={() => this.setState({ filter: 1 })} className={`organization-details-switch-item ${filter === 1 ? "active" : ""}`}>
                            Прайс-лист <span>{active.length}</span>
                        </div>
                        <div onClick={() => this.setState({ filter: 0 })} className={`organization-details-switch-item ${filter === 0 ? "active" : ""}`}>
                            Архив <span>{archived.length}</span>
                        </div>
                    </div>

                    <div onClick={() => this._service.current.open()} className="organization-details-action primary">
                        <Icon name="plus" size={15} width={2.2} />
                        <span>Добавить услугу</span>
                    </div>

                </div>

                <div className="organization-details-section">

                    {shown.length === 0 && <div className="organization-details-empty">{filter === 1 ? "Услуг пока нет" : "В архиве пусто"}</div>}

                    {shown.map(service =>
                        <div key={`${service.id}`} className="organization-details-row">

                            <div className="organization-details-row-main">
                                <div className="organization-details-row-title">{service.name}</div>
                                <div className="organization-details-row-text">
                                    {utils.check(service.category, "Без категории")} · {utils.check(service.sessionTime, "-")} мин
                                </div>
                            </div>

                            <div className="organization-details-row-side">

                                <div className="organization-details-row-price">
                                    {parseInt(service.isFixedPrice) === 0 && service.endPrice
                                        ? `${utils.convertor(service.price)} — ${utils.convertor(service.endPrice, "₸", 1)}`
                                        : utils.convertor(service.price, "₸", 1)
                                    }
                                </div>

                                {service.discount ? <div className="tag orange">Скидка {utils.convertor(service.discount, "₸", 1)}</div> : null}

                                <div className="organization-details-card-tools">

                                    <div onClick={() => this._service.current.open(service.id)} className="organization-details-tool" title="Изменить">
                                        <Icon name="edit" size={15} />
                                    </div>

                                    {parseInt(service.active) !== 0
                                        ? <div onClick={() => this.archive(service, false)} className="organization-details-tool red" title="Архивировать">
                                            <Icon name="archive" size={15} />
                                        </div>
                                        : <div onClick={() => this.archive(service, true)} className="organization-details-tool" title="Вернуть в прайс-лист">
                                            <Icon name="refresh" size={15} />
                                        </div>
                                    }

                                </div>

                            </div>

                        </div>
                    )}

                </div>

                {/* Draw Service */}
                <ServiceModal
                    ref={this._service}
                    organizationID={data.organization.id}
                    categories={utils.check(data.allCategories, [])}
                    team={data.team}
                    onSaved={reload}
                />

            </div>
        )
    }
}

export default ServicesTab
